import MetadataDrivenUI from 'gw-portals-driven-ui-js/MetadataDrivenUI';

export default [() => {
    return new MetadataDrivenUI();
}];